/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ad_Section_Script_TimingInputs */



/**
* | output |
* | --- |
* | "Script Timing" |
*
* @param {Ad_Section_Script_TimingInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ad_section_script_timing = /** @type {((inputs?: Ad_Section_Script_TimingInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ad_Section_Script_TimingInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Timing du script")
	if (locale === "de") return /** @type {LocalizedString} */ ("Skript-Timing")
	if (locale === "it") return /** @type {LocalizedString} */ ("Tempistiche della sceneggiatura")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Синхронизация сценария")
	if (locale === "es") return /** @type {LocalizedString} */ ("Sincronización del guion")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("脚本时间安排")
	if (locale === "ja") return /** @type {LocalizedString} */ ("スクリプトのタイミング")
	if (locale === "hi") return /** @type {LocalizedString} */ ("स्क्रिप्ट टाइमिंग")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Cronograma de Roteiro")
	return /** @type {LocalizedString} */ ("Script Timing")
});